import { StatsFilters as StatsFiltersType } from '../../../../domain/statsFilters';

export const buildSearchParamsFromStatsFilters = (filters?: StatsFiltersType): string => {
    if (!filters) {
        return '';
    }

    const searchParams = new URLSearchParams();

    searchParams.set('timePeriod', filters.timePeriodSelector);

    addTimePeriodSpecificParams(searchParams, filters);

    addCreatorFilter(searchParams, filters);
    addContractorFilter(searchParams, filters);

    return searchParams.toString();
};

const addTimePeriodSpecificParams = (searchParams: URLSearchParams, filters: StatsFiltersType): void => {
    switch (filters.timePeriodSelector) {
        case 'single-month':
            addSingleMonthParams(searchParams, filters);
            break;
        case 'month-range':
            addMonthRangeParams(searchParams, filters);
            break;
        case 'quarter':
            addQuarterParams(searchParams, filters);
            break;
        case 'half-year':
            addHalfYearParams(searchParams, filters);
            break;
        case 'year':
            addYearParams(searchParams, filters);
            break;
        default:
            console.warn(`Unknown time period selector: ${filters.timePeriodSelector}`);
            break;
    }
};

const addSingleMonthParams = (searchParams: URLSearchParams, filters: StatsFiltersType): void => {
    if (!filters.singleMonthYear) {
        console.warn('Single month filter selected but singleMonthYear is missing');
        return;
    }

    const { month, year } = filters.singleMonthYear;
    searchParams.set('month', month.toString());
    searchParams.set('year', year.toString());
};

const addMonthRangeParams = (searchParams: URLSearchParams, filters: StatsFiltersType): void => {
    if (!filters.monthYearRange) {
        console.warn('Month range filter selected but monthYearRange is missing');
        return;
    }

    const { fromMonth, fromYear, toMonth, toYear } = filters.monthYearRange;
    searchParams.set('fromMonth', fromMonth.toString());
    searchParams.set('fromYear', fromYear.toString());
    searchParams.set('toMonth', toMonth.toString());
    searchParams.set('toYear', toYear.toString());
};

const addQuarterParams = (searchParams: URLSearchParams, filters: StatsFiltersType): void => {
    if (!filters.quarter) {
        console.warn('Quarter filter selected but quarter object is missing');
        return;
    }

    const { quarter, year } = filters.quarter;
    searchParams.set('quarter', quarter.toString());
    searchParams.set('year', year.toString());
};

const addHalfYearParams = (searchParams: URLSearchParams, filters: StatsFiltersType): void => {
    if (!filters.halfYear) {
        console.warn('Half-year filter selected but halfYear object is missing');
        return;
    }

    const { halfYear, year } = filters.halfYear;
    searchParams.set('halfYear', halfYear.toString());
    searchParams.set('year', year.toString());
};

const addYearParams = (searchParams: URLSearchParams, filters: StatsFiltersType): void => {
    if (!filters.yearFilter) {
        console.warn('Year filter selected but yearFilter object is missing');
        return;
    }

    const { year } = filters.yearFilter;
    searchParams.set('year', year.toString());
};

const addCreatorFilter = (searchParams: URLSearchParams, filters: StatsFiltersType): void => {
    if (filters.creator?.id) {
        searchParams.set('creatorId', filters.creator.id);
    }
};

const addContractorFilter = (searchParams: URLSearchParams, filters: StatsFiltersType): void => {
    if (filters.contractor?.id) {
        searchParams.set('contractorId', filters.contractor.id);
    }
};
